import Cookies from "js-cookie";
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  setLocalStorage,
  getFromLocalStorage,
  clearLocalStorage,
  setSessionStorage,
  clearSessionStorage,
  getFromSessionStorage,
} from "../utilities/helpers";
import toast from "react-hot-toast";
import axiosConfig from "../utilities/axiosConfig";
import { ENDPOINTS } from "../utilities/constants";

const AuthContext = createContext({
  user: null,
  jwt: null,
});

export const AuthContextProvider = ({ children }) => {
  const [jwt, setJwt] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {

    if (jwt && !user?.on_demands) {
      axiosConfig
        .get(ENDPOINTS["user_on_demands"], {
          headers: {
            Authorization: "Bearer " + jwt,
          },
        })
        .then((response) => {
          const on_demands = response?.data.on_demands;
          setUser((prevState) => ({
            ...prevState,
            on_demands,
          }));
        })
        .catch((error) => console.log("Error -->", error));
    }
  }, [user]);

  const handleLogout = useCallback(() => {
    //* Remove cookies
    clearLocalStorage();
    clearSessionStorage();
    setUser(null);
    setJwt(null);
    toast.success("Επιτυχής αποσύνδεση");
  }, []);

  const handleLogin = useCallback((response, rememberMe = false) => {
    if (!response) return null;
    setUser(response.data.user);
    setJwt(response.data.jwt);

    if (rememberMe) {
      setLocalStorage("user", response.data.user, true);
      setLocalStorage("jwt", response.data.jwt, false);
    } else {
      setSessionStorage("user", response.data.user, true);
      setSessionStorage("jwt", response.data.jwt, false);
    }
  }, []);

  const checkLoginStatus = useCallback(async () => {
    setUser(
      getFromSessionStorage("user", true) ||
        getFromLocalStorage("user", true) ||
        null
    );
    setJwt(
      getFromSessionStorage("jwt", false) ||
        getFromLocalStorage("jwt", false) ||
        null
    );
  }, []);

  useEffect(() => {
    checkLoginStatus();
  }, [checkLoginStatus]);

  const value = useMemo(
    () => ({
      user,
      jwt,
      checkLoginStatus,
      handleLogout,
      handleLogin,
    }),
    [user, jwt, checkLoginStatus, handleLogout, handleLogin]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useAuth must be used within AuthContextProvider");
  }

  return context;
};

export default AuthContext;
